export enum CustomEvent {
  mouseenter = 'mouseover',
  mouseleave = 'mouseout'
}
